(function () {
  'use strict';

  var KEY = 'mp:favs';
  var tv = window.themeVariables || {};
  var routes = tv.routes || {};
  var einstellungen = tv.settings || {};
  var cartAdd = (routes.cartAddUrl || '/cart/add') + '.js';
  var cartGet = (routes.cartUrl || '/cart') + '.js';

  function ruhig() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  var Fav = {
    read: function () {
      try {
        var v = JSON.parse(localStorage.getItem(KEY));
        return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string'; }) : [];
      } catch (e) { return []; }
    },
    write: function (list) {
      try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 200))); } catch (e) {}
      document.documentElement.dispatchEvent(new CustomEvent('mp:favs', {
        bubbles: true, detail: { list: list }
      }));
    },
    has: function (h) { return this.read().indexOf(h) > -1; },
    toggle: function (h) {
      var l = this.read(), i = l.indexOf(h);
      if (i > -1) { l.splice(i, 1); } else { l.unshift(h); }
      this.write(l);
      return i === -1;
    }
  };
  window.MagicPearlFavs = Fav;

  function favSync() {
    var list = Fav.read();
    Array.prototype.forEach.call(document.querySelectorAll('.mp-fav'), function (b) {
      var on = list.indexOf(b.getAttribute('data-handle')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    Array.prototype.forEach.call(document.querySelectorAll('mp-fav-count'), function (c) {
      c.textContent = list.length;
      if (list.length) { c.removeAttribute('hidden'); } else { c.setAttribute('hidden', ''); }
    });
  }

  var konfig = window.mpFavKonfig || {};

  function klaviyo(name, b) {
    var q = window._learnq;
    if (!q || !b) return;
    try {
      if (konfig.email) q.push(['identify', { '$email': konfig.email }]);
      q.push(['track', name, {
        ProductName: b.getAttribute('data-titel') || '',
        ProductID: b.getAttribute('data-produkt-id') || '',
        Handle: b.getAttribute('data-handle') || '',
        URL: b.getAttribute('data-url') || '',
        ImageURL: b.getAttribute('data-bild') || '',
        Price: parseFloat(b.getAttribute('data-preis') || '0'),
        Currency: konfig.waehrung || 'EUR'
      }]);
    } catch (e) {}
  }

  var toast = null;

  function holeToast() {
    if (toast && toast.isConnected) return toast;
    toast = document.createElement('div');
    toast.className = 'mp-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast._innen = document.createElement('div');
    toast._innen.className = 'mp-toast__innen';
    toast.appendChild(toast._innen);
    document.body.appendChild(toast);
    return toast;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', holeToast);
  } else {
    holeToast();
  }

  function meldung(text, an) {
    holeToast();
    toast.classList.toggle('mp-toast--weg', !an);

    toast._innen.innerHTML =
      '<svg class="mp-toast__ico" viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">' +
      '<path d="M12 20.8 3.9 12.7a5.2 5.2 0 0 1 7.35-7.35L12 6.1l.75-.75a5.2 5.2 0 0 1 7.35 7.35Z" ' +
      'fill="' + (an ? 'currentColor' : 'none') + '" stroke-linejoin="round"/></svg>';

    var wort = document.createElement('span');
    wort.textContent = text;
    toast._innen.appendChild(wort);

    void toast.offsetWidth;
    toast.classList.add('is-da');
    clearTimeout(toast._weg);
    toast._weg = setTimeout(function () { toast.classList.remove('is-da'); }, 2200);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.mp-fav');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var h = b.getAttribute('data-handle');
    if (!h) return;
    var on = Fav.toggle(h);
    klaviyo(on ? 'Zur Wunschliste hinzugefügt' : 'Von der Wunschliste entfernt', b);
    meldung(on ? 'Zur Wunschliste hinzugefügt' : 'Von der Wunschliste entfernt', on);
    b.classList.toggle('is-on', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    if (on && !ruhig()) {
      b.classList.remove('is-pop');
      void b.offsetWidth;
      b.classList.add('is-pop');
    }
  });

  document.documentElement.addEventListener('mp:favs', function () { favSync(); });

  function perleFliegen(von) {
    if (ruhig()) return;
    var ziel = document.querySelector('cart-count') ||
               document.querySelector('[aria-controls="mini-cart"]');
    if (!ziel || !von) return;
    var a = von.getBoundingClientRect(), b = ziel.getBoundingClientRect();
    if (!a.width || !b.width) return;

    var dx = (b.left + b.width / 2) - (a.left + a.width / 2);
    var dy = (b.top + b.height / 2) - (a.top + a.height / 2);

    var bahn = document.createElement('span');
    bahn.className = 'mp-fly';
    bahn.style.left = (a.left + a.width / 2) + 'px';
    bahn.style.top = (a.top + a.height / 2) + 'px';
    var kern = document.createElement('span');
    kern.className = 'mp-fly__kern';
    bahn.appendChild(kern);
    document.body.appendChild(bahn);

    void bahn.offsetWidth;
    bahn.style.transform = 'translateX(' + dx + 'px)';
    kern.style.transform = 'translateY(' + dy + 'px) scale(.35)';
    kern.style.opacity = '.2';
    setTimeout(function () { bahn.remove(); }, 760);

    ziel.classList.remove('is-bump');
    void ziel.offsetWidth;
    ziel.classList.add('is-bump');
  }

  function inDenKorb(id) {
    return fetch(cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (j) {
          throw new Error(j.description || j.message || 'Fehler');
        });
      }
      return r.json();
    }).then(function () {
      return fetch(cartGet, { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
    }).then(function (cart) {
      var root = document.documentElement;
      root.dispatchEvent(new CustomEvent('variant:added', { bubbles: true, detail: { variant: { id: id } } }));
      root.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
      root.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart: cart, openMiniCart: einstellungen.cartType === 'drawer' }
      }));
      return cart;
    });
  }

  function zustand(qa, name) {
    qa.setAttribute('data-state', name);
    var btn = qa.querySelector('.mp-qa__btn');
    if (btn) btn.disabled = (name === 'laedt');
  }

  function erledigt(qa, von) {
    zustand(qa, 'drin');
    perleFliegen(von || qa);
    clearTimeout(qa._zurueck);
    qa._zurueck = setTimeout(function () { zustand(qa, 'bereit'); }, 1900);
  }

  function fehler(qa, text) {
    zustand(qa, 'fehler');
    qa.setAttribute('title', text || '');
    clearTimeout(qa._zurueck);
    qa._zurueck = setTimeout(function () {
      zustand(qa, 'bereit');
      qa.removeAttribute('title');
    }, 2600);
  }

  function daten(qa) {
    var leer = { opts: [], vars: [], bild: {}, sw: [] };
    var s = qa.querySelector('script.mp-qa__data');
    if (!s) return leer;
    try {
      var d = JSON.parse(s.textContent);
      return { opts: d.opts || [], vars: d.vars || [], bild: d.bild || {}, sw: d.sw || [] };
    } catch (e) { return leer; }
  }

  function bildStellen(karte, mediaId, adresse) {
    if (!karte) return;
    karte.classList.add('mp-bild-fix');
    var spurZurueck = karte.querySelector('[data-spur]');
    if (spurZurueck) spurZurueck.scrollLeft = 0;

    var bilder = karte.querySelectorAll('img[data-media-id]');
    if (mediaId && bilder.length > 1) {
      var treffer = false;
      Array.prototype.forEach.call(bilder, function (b) {
        if (String(b.getAttribute('data-media-id')) === String(mediaId)) treffer = true;
      });
      if (treffer) {
        Array.prototype.forEach.call(bilder, function (b) {
          var ist = String(b.getAttribute('data-media-id')) === String(mediaId);
          if (ist) { b.removeAttribute('hidden'); } else { b.setAttribute('hidden', ''); }
        });
        return;
      }
    }

    if (!adresse) return;
    var sichtbar = karte.querySelector('.pearl-item__img:not([hidden])');
    if (!sichtbar || sichtbar.getAttribute('src') === adresse) return;
    sichtbar.removeAttribute('srcset');
    sichtbar.removeAttribute('sizes');
    sichtbar.setAttribute('src', adresse);
  }

  function swatchMarkieren(karte, wert) {
    if (!karte || !wert) return;
    var sw = karte.querySelectorAll('.pearl-swatch');
    Array.prototype.forEach.call(sw, function (s) {
      var ist = (s.getAttribute('aria-label') || '') === wert;
      if (ist) { s.setAttribute('aria-current', 'true'); }
      else { s.removeAttribute('aria-current'); }
    });
  }

  function blattSchliessen(karte) {
    var b = karte && karte.querySelector('.mp-sheet');
    if (!b) return;

    b.classList.remove('is-auf');
    setTimeout(function () {
      if (b.parentNode) b.remove();
      if (!karte.querySelector('.mp-sheet')) karte.classList.remove('mp-blende-farben');
    }, 440);
    karte.classList.remove('mp-hat-blatt');
  }

  function werteVon(vars, i) {
    var raus = [];
    vars.forEach(function (v) {
      if (v.o[i] != null && raus.indexOf(v.o[i]) === -1) raus.push(v.o[i]);
    });
    return raus;
  }

  function blattOeffnen(qa) {
    var karte = qa.closest('.pearl-item');
    var feld = karte && karte.querySelector('.pearl-item__media');
    if (!feld) return;

    Array.prototype.forEach.call(document.querySelectorAll('.pearl-item.mp-hat-blatt'), function (k) {
      if (k !== karte) blattSchliessen(k);
    });
    if (karte.querySelector('.mp-sheet')) { blattSchliessen(karte); return; }

    var d = daten(qa);
    var wahl = [];
    var manuell = [];   

    d.opts.forEach(function (n, i) {
      if (werteVon(d.vars, i).length === 1) wahl[i] = werteVon(d.vars, i)[0];
    });

    var aktiv = karte.querySelector('.pearl-swatch[aria-current="true"]');
    if (aktiv) {
      var name = aktiv.getAttribute('aria-label');
      d.opts.forEach(function (n, i) {
        if (wahl[i] == null && werteVon(d.vars, i).indexOf(name) > -1) wahl[i] = name;
      });
    }

    var blatt = document.createElement('div');
    blatt.className = 'mp-sheet';
    blatt.setAttribute('role', 'group');
    feld.appendChild(blatt);
    karte.classList.add('mp-hat-blatt');
    void blatt.offsetWidth;
    blatt.classList.add('is-auf');

    function offen() {
      for (var i = 0; i < d.opts.length; i++) { if (wahl[i] == null) return i; }
      return -1;
    }

    function passt(i, wert) {
      return d.vars.filter(function (v) {
        if (v.o[i] !== wert) return false;
        for (var k = 0; k < d.opts.length; k++) {
          if (k !== i && wahl[k] != null && v.o[k] !== wahl[k]) return false;
        }
        return true;
      });
    }

    function treffer() {
      return d.vars.filter(function (v) {
        for (var k = 0; k < d.opts.length; k++) {
          if (wahl[k] != null && v.o[k] !== wahl[k]) return false;
        }
        return true;
      })[0];
    }

    function absenden() {
      var v = treffer();
      if (!v || !v.a) { blattSchliessen(karte); fehler(qa, 'Diese Zusammenstellung ist nicht verfügbar'); return; }
      zustand(qa, 'laedt');
      inDenKorb(v.id).then(function () {
        blattSchliessen(karte);
        erledigt(qa, qa);
      }).catch(function (err) {
        blattSchliessen(karte);
        fehler(qa, err && err.message);
      });
    }

    function karteBietet(i) {
      if (i !== 0) return null;
      var reihe = karte.querySelector('.pearl-swatches');
      if (!reihe) return null;
      if (!reihe.querySelector('.pearl-swatch')) return null;
      return reihe;
    }

    function zeichne() {
      var i = offen();
      karte.classList.remove('mp-blende-farben');
      if (i === -1) { absenden(); return; }

      var werte = werteVon(d.vars, i);
      var kopf = '<div class="mp-sheet__kopf"><span>' + d.opts[i] +
        (d.opts.length > 1 ? ' <em>' + (i + 1) + '/' + d.opts.length + '</em>' : '') +
        ' <b class="mp-sheet__wert"></b>' +
        '</span><span class="mp-sheet__ecke">' +
        (manuell.length ? '<button type="button" class="mp-sheet__rueck" aria-label="Zurück"><svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true"><path d="M10 2 4 8l6 6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' : '') +
        '<button type="button" class="mp-sheet__zu" aria-label="Schließen"><svg viewBox="0 0 16 16" width="12" height="12" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></button>' +
        '</span></div>';

      var flaechen = (d.sw && d.sw[i]) || {};
      var mitFlaeche = werte.filter(function (w) { return flaechen[w]; }).length;
      var alsFlaeche = werte.length > 0 && mitFlaeche >= Math.ceil(werte.length / 2);

      var reihe = werte.map(function (w) {
        var moeglich = passt(i, w).some(function (v) { return v.a; });
        var attr = (moeglich ? '' : ' disabled') + ' data-i="' + i + '" data-wert="' +
          String(w).replace(/"/g, '&quot;') + '"';

        if (alsFlaeche) {
          var stil = flaechen[w] || '';
          return '<button type="button" class="mp-sheet__sw' + (moeglich ? '' : ' is-weg') + '"' +
            attr + ' title="' + String(w).replace(/"/g, '&quot;') + '"' +
            ' aria-label="' + String(w).replace(/"/g, '&quot;') + '"' +
            ' style="' + stil.replace(/"/g, '&quot;') + '"></button>';
        }

        return '<button type="button" class="mp-sheet__opt' + (moeglich ? '' : ' is-weg') + '"' +
          attr + '>' + w + '</button>';
      }).join('');

      blatt.innerHTML = kopf +
        '<div class="mp-sheet__reihe' + (alsFlaeche ? ' mp-sheet__reihe--sw' : '') + '">' + reihe + '</div>';

      if (karteBietet(i)) karte.classList.add('mp-blende-farben');

      var anzeige = blatt.querySelector('.mp-sheet__wert');
      if (anzeige && alsFlaeche) {
        var zeigeName = function (ev) {
          var t = ev.target.closest('.mp-sheet__sw');
          anzeige.textContent = t ? (t.getAttribute('aria-label') || '') : '';
        };
        blatt.addEventListener('pointerover', zeigeName);
        blatt.addEventListener('focusin', zeigeName);
        blatt.addEventListener('pointerleave', function () { anzeige.textContent = ''; });
      }

      var erste = blatt.querySelector('.mp-sheet__sw:not([disabled]), .mp-sheet__opt:not([disabled])');
      if (erste) erste.focus({ preventScroll: true });
    }

    blatt.addEventListener('click', function (ev) {
      ev.stopPropagation();
      if (ev.target.closest('.mp-sheet__zu')) { blattSchliessen(karte); return; }
      if (ev.target.closest('.mp-sheet__rueck')) {
        var letzte = manuell.pop();
        if (letzte != null) wahl[letzte] = null;
        zeichne();
        return;
      }
      var o = ev.target.closest('.mp-sheet__opt, .mp-sheet__sw');
      if (!o || o.disabled) return;

      var i = parseInt(o.getAttribute('data-i'), 10);
      wahl[i] = o.getAttribute('data-wert');
      manuell.push(i);

      var v = passt(i, wahl[i]).filter(function (x) { return x.a; })[0] || passt(i, wahl[i])[0];
      bildStellen(karte, v && v.m, i === 0 ? d.bild[wahl[i]] : null);
      swatchMarkieren(karte, wahl[i]);

      zeichne();
    });

    zeichne();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.mp-qa__btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var qa = btn.closest('mp-quick-add');
    if (!qa || qa.getAttribute('data-state') === 'laedt') return;

    var d = daten(qa);
    if (!d.vars.some(function (v) { return v.a; })) return;

    if (d.vars.length === 1) {
      zustand(qa, 'laedt');
      inDenKorb(d.vars[0].id)
        .then(function () { erledigt(qa, btn); })
        .catch(function (err) { fehler(qa, err && err.message); });
      return;
    }
    blattOeffnen(qa);
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('.mp-sheet')) return;
    if (e.target.closest('mp-quick-add')) return;

    Array.prototype.forEach.call(document.querySelectorAll('.pearl-item.mp-hat-blatt'), blattSchliessen);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    Array.prototype.forEach.call(document.querySelectorAll('.pearl-item.mp-hat-blatt'), blattSchliessen);
  });

  function klonSetzen(karte) {
    if (!karte) return;
    var spur = karte.querySelector('[data-spur]');
    if (!spur || spur.querySelector('[data-klon]')) return;
    var dias = spur.querySelectorAll('.pearl-item__dia');
    if (dias.length < 2) return;
    var klon = dias[0].cloneNode(true);
    klon.setAttribute('data-klon', '');
    klon.setAttribute('aria-hidden', 'true');
    spur.appendChild(klon);
  }

  function echteDias(spur) {
    return spur.querySelectorAll('.pearl-item__dia:not([data-klon])').length;
  }

  function punkteSetzen(karte) {
    if (!karte) return;
    var spur = karte.querySelector('[data-spur]');
    var punkte = karte.querySelector('[data-punkte]');
    if (!spur || !punkte) return;

    var breite = spur.clientWidth || 1;
    var i = Math.round(spur.scrollLeft / breite);
    var echt = echteDias(spur);

    if (echt && i >= echt) {
      i = 0;
      var aufKlon = Math.abs(spur.scrollLeft - breite * echt) < 4;
      if (aufKlon && !spur._mpFinger) spurUmsetzen(spur, 0);
    }

    var alle = punkte.children;
    for (var k = 0; k < alle.length; k++) {
      alle[k].classList.toggle('is-hier', k === i);
    }

    var zur = karte.querySelector('.pearl-item__pfeil--zurueck');
    var vor = karte.querySelector('.pearl-item__pfeil--vor');
    if (zur) zur.disabled = false;
    if (vor) vor.disabled = false;
  }

  function spurUmsetzen(spur, links) {
    if (Math.abs(spur.scrollLeft - links) < 2) return;
    var vorher = spur.style.scrollBehavior;
    spur.style.scrollBehavior = 'auto';
    spur.scrollLeft = links;
    requestAnimationFrame(function () { spur.style.scrollBehavior = vorher; });
  }

  var wischStart = null;
  var wischKarte = null;

  document.addEventListener('touchstart', function (e) {
    var spur = e.target.closest && e.target.closest('[data-spur]');
    if (spur) spur._mpFinger = true;

    wischStart = null;
    wischKarte = null;
    if (e.touches.length !== 1) return;
    var link = e.target.closest && e.target.closest('.pearl-item__image-link');
    if (!link) return;
    wischKarte = link;
    wischStart = { x: e.touches[0].clientX, y: e.touches[0].clientY };
    link._mpGewischt = false;
  }, { passive: true, capture: true });

  document.addEventListener('touchmove', function (e) {
    if (!wischStart || !wischKarte || e.touches.length !== 1) return;
    var dx = Math.abs(e.touches[0].clientX - wischStart.x);
    var dy = Math.abs(e.touches[0].clientY - wischStart.y);
    if (dx > 8 || dy > 8) wischKarte._mpGewischt = true;
  }, { passive: true, capture: true });

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.pearl-item__image-link');
    if (!link || !link._mpGewischt) return;
    link._mpGewischt = false;
    e.preventDefault();
    e.stopPropagation();
  }, true);

  document.addEventListener('touchend', function (e) {
    var spur = e.target.closest && e.target.closest('[data-spur]');
    if (!spur) return;
    spur._mpFinger = false;
    setTimeout(function () { punkteSetzen(spur.closest('.pearl-item')); }, 400);
    setTimeout(function () { punkteSetzen(spur.closest('.pearl-item')); }, 900);
  }, { passive: true, capture: true });

  document.addEventListener('scroll', function (e) {
    var spur = e.target;
    if (!spur || !spur.hasAttribute || !spur.hasAttribute('data-spur')) return;
    clearTimeout(spur._punktzeit);
    spur._punktzeit = setTimeout(function () {
      punkteSetzen(spur.closest('.pearl-item'));
    }, 60);
  }, true);

  document.addEventListener('click', function (e) {
    var p = e.target.closest && e.target.closest('.pearl-item__pfeil');
    if (!p) return;
    e.preventDefault();
    e.stopPropagation();
    var karte = p.closest('.pearl-item');
    var spur = karte && karte.querySelector('[data-spur]');
    if (!spur) return;
    karte._handisch = true;

    var richtung = parseInt(p.getAttribute('data-pfeil'), 10);
    var breite = spur.clientWidth || 1;
    var i = Math.round(spur.scrollLeft / breite);
    var echt = echteDias(spur);

    if (richtung > 0) {
      spur.scrollBy({ left: breite, behavior: 'smooth' });
    } else if (i <= 0) {
      spurUmsetzen(spur, breite * (echt - 1));
    } else {
      spur.scrollBy({ left: -breite, behavior: 'smooth' });
    }
    setTimeout(function () { punkteSetzen(karte); }, 450);
  });

  function galerienSetzen() {
    Array.prototype.forEach.call(document.querySelectorAll('.pearl-item [data-punkte]'), function (p) {
      var karte = p.closest('.pearl-item');
      klonSetzen(karte);
      punkteSetzen(karte);
    });
  }

  function favZaehlText(n) { return n === 1 ? '1 Stück' : n + ' Stücke'; }

  function geteilteListe() {
    var m = location.search.match(/[?&]liste=([^&]+)/);
    if (!m) return null;
    var roh;
    try { roh = decodeURIComponent(m[1]); } catch (e) { return null; }
    var l = roh.split(',').map(function (x) { return x.trim(); })
      .filter(function (x) { return /^[a-z0-9-]{1,120}$/i.test(x); })
      .slice(0, 60);
    return l.length ? l : null;
  }

  function teilenLink() {
    var l = Fav.read().slice(0, 60);
    if (!l.length) return '';
    var basis = (konfig.seite || '/').replace(/\/$/, '');
    return location.origin + basis + '/pages/favoriten?liste=' + encodeURIComponent(l.join(','));
  }

  function favLeerPruefen(wurzel) {
    var gitter = wurzel.querySelector('[data-fav-gitter]');
    var leer = wurzel.querySelector('[data-fav-leer]');
    var voll = gitter.querySelector('.mp-favs__zelle');
    gitter.hidden = !voll;
    leer.hidden = !!voll;
  }

  function zeigen(el, ja) { if (el) { if (ja) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); } } }

  function favSeite() {
    var wurzel = document.querySelector('[data-fav-root]');
    if (!wurzel) return;

    var gitter = wurzel.querySelector('[data-fav-gitter]');
    var leer = wurzel.querySelector('[data-fav-leer]');
    var zeile = wurzel.querySelector('[data-fav-zeile]');
    var geteilt = geteilteListe();
    var liste = geteilt || Fav.read();

    wurzel.classList.toggle('is-geteilt', !!geteilt);
    zeigen(wurzel.querySelector('[data-fav-teilen]'), !geteilt && liste.length > 0);

    zeile.textContent = liste.length ? favZaehlText(liste.length) : '';
    if (!liste.length) { gitter.hidden = true; leer.hidden = false; gitter.innerHTML = ''; return; }

    leer.hidden = true;
    gitter.hidden = false;
    gitter.innerHTML = liste.map(function () { return '<div class="mp-favs__warten"></div>'; }).join('');

    var basis = routes.rootUrlWithoutSlash || '';
    Promise.all(liste.map(function (h) {
      return fetch(basis + '/products/' + encodeURIComponent(h) + '?section_id=mp-fav-card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (teile) {
      var hof = document.createElement('div');
      teile.forEach(function (t) {
        if (!t) return;
        var dd = document.createElement('div');
        dd.innerHTML = t;
        var z = dd.querySelector('.mp-favs__zelle');
        if (z) hof.appendChild(z);
      });
      gitter.innerHTML = hof.innerHTML;
      favLeerPruefen(wurzel);
      favSync();
      galerienSetzen();
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-fav-teilen]');
    if (!b) return;
    e.preventDefault();
    var url = teilenLink();
    if (!url) return;

    function bestaetigen() {
      var label = b.querySelector('[data-fav-teilen-label]');
      b.classList.add('is-kopiert');
      if (label) {
        if (!b.getAttribute('data-alt')) b.setAttribute('data-alt', label.textContent);
        label.textContent = b.getAttribute('data-kopiert') || 'Link kopiert';
      }
      clearTimeout(b._zurueck);
      b._zurueck = setTimeout(function () {
        b.classList.remove('is-kopiert');
        if (label) label.textContent = b.getAttribute('data-alt') || label.textContent;
      }, 2200);
    }

    function altKopieren() {
      try {
        var f = document.createElement('textarea');
        f.value = url;
        f.setAttribute('readonly', '');
        f.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;padding:0;border:0;opacity:0;pointer-events:none';
        document.body.appendChild(f);
        f.select();
        if (f.setSelectionRange) f.setSelectionRange(0, url.length);
        var ok = document.execCommand('copy');
        f.parentNode.removeChild(f);
        return ok;
      } catch (err) {
        return false;
      }
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url)
        .then(bestaetigen)
        .catch(function () {
          if (altKopieren()) { bestaetigen(); } else { linkZeigen(b, url); }
        });
      return;
    }
    if (altKopieren()) { bestaetigen(); return; }
    linkZeigen(b, url);
  });

  function linkZeigen(b, url) {
    var feld = document.querySelector('[data-fav-linkfeld]');
    if (!feld) return;
    feld.value = url;
    feld.removeAttribute('hidden');
    feld.focus();
    feld.select();
  }

  document.documentElement.addEventListener('mp:favs', function (e) {
    var wurzel = document.querySelector('[data-fav-root]');
    if (!wurzel) return;

    if (wurzel.classList.contains('is-geteilt')) return;

    var liste = (e.detail && e.detail.list) || Fav.read();
    var gitter = wurzel.querySelector('[data-fav-gitter]');
    wurzel.querySelector('[data-fav-zeile]').textContent = liste.length ? favZaehlText(liste.length) : '';
    zeigen(wurzel.querySelector('[data-fav-teilen]'), liste.length > 0);

    var vorhanden = [];
    Array.prototype.forEach.call(gitter.querySelectorAll('.mp-favs__zelle'), function (z) {
      var h = z.getAttribute('data-handle');
      vorhanden.push(h);
      if (liste.indexOf(h) === -1) {
        z.classList.add('is-weg');
        setTimeout(function () { z.remove(); favLeerPruefen(wurzel); }, 260);
      }
    });

    if (liste.filter(function (h) { return vorhanden.indexOf(h) === -1; }).length) favSeite();
  });

  function start() { favSync(); favSeite(); galerienSetzen(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  var warte = null;
  new MutationObserver(function () {
    clearTimeout(warte);
    warte = setTimeout(favSync, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

(function () {
  var DAUER = 260;
  var EASE = 'cubic-bezier(.23,1,.32,1)';   

  function ruhig() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function kannAnimieren(el) {
    return typeof el.animate === 'function';
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var kopf = e.target.closest('.mp-akk__kopf');
    if (!kopf) return;

    var det = kopf.parentElement;
    if (!det || det.tagName !== 'DETAILS') return;

    var inhalt = det.querySelector('.mp-akk__inhalt');
    if (!inhalt || ruhig() || !kannAnimieren(inhalt)) return;   

    e.preventDefault();
    schalte(det, inhalt);
  });

  function schalte(det, inhalt) {
    if (det._mpAkkAnim) {
      det._mpAkkAnim.cancel();
      det._mpAkkAnim = null;
      det._mpAkkLief = true;
    }

    var laeuft = !!det._mpAkkLief;
    var auf = !det.open;
    var von = (auf && !laeuft) ? 0 : inhalt.getBoundingClientRect().height;

    if (auf) {
      det.open = true;
      det.classList.remove('mp-akk--schliesst');
    } else {
      det.classList.add('mp-akk--schliesst');
    }

    var bis = auf ? inhalt.scrollHeight : 0;

    var stil = window.getComputedStyle(inhalt);
    if (!det._mpAkkPolster && parseFloat(stil.paddingBottom) > 0) {
      det._mpAkkPolster = [stil.paddingTop, stil.paddingBottom];
    }
    var polster = det._mpAkkPolster || ['0px', '0px'];

    inhalt.style.overflow = 'hidden';
    var a = inhalt.animate(
      [
        {
          height: von + 'px',
          paddingTop:    auf ? '0px' : polster[0],
          paddingBottom: auf ? '0px' : polster[1],
          opacity: auf ? 0 : 1
        },
        {
          height: bis + 'px',
          paddingTop:    auf ? polster[0] : '0px',
          paddingBottom: auf ? polster[1] : '0px',
          opacity: auf ? 1 : 0
        }
      ],
      { duration: DAUER, easing: EASE }
    );
    det._mpAkkAnim = a;
    det._mpAkkLief = true;

    a.finished.then(function () {
      inhalt.style.overflow = '';
      det._mpAkkAnim = null;
      det._mpAkkLief = false;
      if (!auf) {
        det.open = false;
        det.classList.remove('mp-akk--schliesst');
      }
    }, function () {
      inhalt.style.overflow = 'hidden';
    });
  }
})();

(function () {
  'use strict';

  function pruefen(el) {
    var zahl = parseInt(String(el.textContent || '').replace(/[^0-9]/g, ''), 10);
    var leer = !(zahl > 0);
    if (el.classList.contains('mp-leer') !== leer) el.classList.toggle('mp-leer', leer);
  }

  function beobachten(el) {
    if (el._mpLeerBeobachtet) return;
    el._mpLeerBeobachtet = true;
    pruefen(el);
    if (!window.MutationObserver) return;
    new MutationObserver(function () { pruefen(el); })
      .observe(el, { childList: true, characterData: true, subtree: true });
  }

  function alle() {
    Array.prototype.forEach.call(document.querySelectorAll('cart-count'), beobachten);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alle);
  } else {
    alle();
  }

  ['cart:updated', 'cart:refresh', 'variant:added'].forEach(function (name) {
    document.documentElement.addEventListener(name, function () { setTimeout(alle, 0); });
  });
})();
